/** Utah's words for home/guides-grooming.ts. */
export const GUIDES_GROOMING_UT = {
  /** The clipper guide's "suggested" line: whether the state's barber and cosmetology rule on disinfecting tools was confirmed (Utah: not found). */
  clipperSuggested: "At home this is good practice, not law. Utah's rules for licensed barbers were not confirmed here; a shop follows its own license rules.",
} as const;
